export interface ForwardLookingCellProps {
  /** Why the data is not here yet, read by assistive tech (e.g. "Arrives with the M6 Case module"). */
  reason: string
}

/**
 * The "future-proofed shape, not absent" cell pattern: a muted en-dash for a
 * column whose data model exists in the IA contract but has no source module
 * yet (Case / Fiscal year before M6 ships). Non-interactive — this is not a
 * disabled link, it never was a link. Design-system.md gap: this pattern has
 * no §3.2 entry yet; recommend adding one (see UX report).
 */
export function ForwardLookingCell({ reason }: ForwardLookingCellProps) {
  return (
    <span aria-label={`Not available yet — ${reason}`} style={{ color: 'var(--iw-text-subtle)' }}>
      –
    </span>
  )
}
